export default class HeadFoot {
    constructor() {
        this.init();
    }

    init() {
        this.setGnav();
    }

    setGnav() {
        const trigger = [...document.querySelectorAll(".js-gnavopen")];
        const menuItem = [...document.querySelectorAll(".js-gnavitem")];

        trigger.forEach((el) => {
            el.addEventListener("click", (e) => {
                if (document.body.getAttribute("data-gnavactive")) {
                    document.body.removeAttribute("data-lock");
                    document.body.removeAttribute("data-gnavactive");
                    document.body.removeAttribute("data-gnavactive_after");
                } else {
                    document.body.setAttribute("data-lock", "1");
                    document.body.setAttribute("data-gnavactive", "1");
                    setTimeout(() => {
                        document.body.setAttribute("data-gnavactive_after", "1");
                    }, 500);
                }
            });
        });

        menuItem.forEach((el) => {
            el.addEventListener("click", (e) => {
                document.body.removeAttribute("data-lock");
                document.body.removeAttribute("data-gnavactive");
            });
        });
    }
}
